import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTypes } from 'actions/status';
import { setUser, getMe, getTenant } from 'actions/user';
import { getEducationGroups } from 'actions/sections';
import { getUser } from 'lib/msal';
import { getActiveLanguage, translate } from '@haldor/ui'; // Import routes

import PrintAssignment from 'containers/PrintPages/PrintAssignment';
import PrintPlan from 'containers/PrintPages/PrintPlanning';

var PrintApp = /*#__PURE__*/function (_Component) {
  _inherits(PrintApp, _Component);

  var _super = _createSuper(PrintApp);

  function PrintApp() {
    _classCallCheck(this, PrintApp);

    return _super.apply(this, arguments);
  }

  _createClass(PrintApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.languages != null) {
        var lang = getActiveLanguage();

        if (lang == 'sv-se') {
          this.props.getTypes("sv-SE").then(function () {});
        } else if (lang == 'da-dk') {
          this.props.getTypes("da-DK").then(function () {});
        } else if (lang == 'nb-no') {
          this.props.getTypes("nb-no");
        } else if (lang == 'uk') {
          this.props.getTypes("uk");
        } else {
          this.props.getTypes("en-US").then(function () {});
        }
      }

      this.props.getEducationGroups();
      var user = getUser();
      this.props.setUser(user);
      this.props.getMe();
      this.props.getTenant();
      var isFrame = this.isIframe();

      if (isFrame) {
        this.setState({
          background: '#f5f5f5'
        });
      }
    }
  }, {
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "app-comp-content content"
      }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: "/print/assignment/:assignmentId",
        component: PrintAssignment
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/print/assignments-tab/:assignmentId",
        component: PrintAssignment
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/print/plan/:planId",
        component: PrintPlan
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/print/planning-tab/:planId",
        component: PrintPlan
      })));
    }
  }]);

  return PrintApp;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages
  };
};

var mapDispatchToProps = {
  getTypes: getTypes,
  setUser: setUser,
  getEducationGroups: getEducationGroups,
  getMe: getMe,
  getTenant: getTenant
};
export default connect(mapStateToProps, mapDispatchToProps)(PrintApp);